import proxy from "../src/functions/Proxy";
import mitt from "mitt";

const emitter = mitt();
var isApp = null;
export default function AppClass() {
    async function Ready() {
        if (typeof window.cefSharp !== "undefined") {
            await window.cefSharp.bindObjectAsync("$app");

            isApp = (function(window) {
                return (function(isApp) {
                    return isApp;
                })(window.$app || false);
            })(window || {});
            return window.$app;
        }
        return null;
    }

    function emit () {
        var evArgs = Array.from(arguments);
        var evName = evArgs.shift();

        return emitter.emit(evName, [...evArgs]);
    }

    function on (evName, evHandle) {
        emitter.on(evName, function (evArgs) {
            evHandle.apply(this, evArgs);
        });
    }

    Object.defineProperties(this, {
        Emit: proxy.ForGet(emit),
        On: proxy.ForGet(on),
        Off: proxy.ForGet(emitter.off, emitter),
        Once: proxy.ForGet(emitter.on, emitter),
    });

    Object.defineProperty(this, "Ready", {
        get() {
            return Ready;
        }
    });

    Object.defineProperty(this, "IsNative", {
        get() {
            return !!isApp;
        }
    });
}
